// Socialplus 커스텀
console.log("Start - Socialplus Custom Script");

function initSocialLoginText() {
  const wrappers = document.querySelectorAll('.socialplus-login-button-wrapper');
  if (wrappers.length === 0) return;

  console.log("✔ SocialPlus Detected");

  // 중복 삽입 방지
  if (wrappers[0].dataset.customized === '1') return;
  wrappers[0].dataset.customized = '1';

  // 상단 문구
  const createLineDescTop = () => {
    const box = document.createElement('div');
    box.classList.add('social-desc-top');
    box.innerHTML = `
      <p>会員登録後、<br>初回購入が10％OFF！</p>
      <p class='social-desc-sub'>※3,000円以上のご購入で購入ページにて自動適用</p>
    `;
    return box;
  };

  const createLineDesc = () => {
    const box = document.createElement('div');
    box.classList.add('social-desc-line', 'login-custom');
    box.innerHTML = `
      <hr><p>LINEでログインする方はこちら</p><hr>
      <div class='social-desc-top'>LINE連携すると、<br>ダルバの新作＆プロモーション<br>情報を最速でお届け！</div>
    `;
    return box;
  };

  // 버튼 뒤에 붙는 문구
  const createLineDescSub = () => {
    const p = document.createElement('p');
    p.classList.add('social-desc-sub');
    p.innerHTML = `
      ※LINE友だち追加が必要になります。<br>
      ※クーポンはLINEメッセージにて配布いたします。
    `;
    return p;
  };

  // 구글 문구
  const createGoogleDesc = () => {
    const box = document.createElement('div');
    box.classList.add('social-desc-google', 'login-custom');
    box.innerHTML = `<hr><p>Googleアカウントをお持ちの方はこちら</p><hr>`;
    return box;
  };

  const lineWrapper = wrappers[0];
  const googleWrapper = wrappers[1];

  if (lineWrapper) {
    // ✔ 1) wrapper 맨 위에 상단 문구 넣기
    lineWrapper.insertBefore(createLineDesc(), lineWrapper.firstChild);
    lineWrapper.insertBefore(createLineDescTop(), lineWrapper.firstChild);

    if (window.location.href.includes('account/login')){
      lineWrapper.querySelector('text').textContent = 'LINEでログイン';
    }


    // ✔ 2) 버튼 뒤에 서브 텍스트 넣기
    // const button = lineWrapper.querySelector('.socialplus-login-button-component');
    // if (button) {
    //   button.insertAdjacentElement('afterend', createLineDescSub());
    // }
  }

  if (googleWrapper) {
    googleWrapper.insertBefore(createGoogleDesc(), googleWrapper.firstChild);
  }
}

// 앱이 DOM 생성하는 순간 감지
const observer = new MutationObserver(() => {
  initSocialLoginText();
});
observer.observe(document.body, { childList: true, subtree: true });


